import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { successNotificationWrapper } from '../../logic/helpers/NotificationService'

@Component({})
export default class ClipboardCopyMixin extends Vue {
  copy(textToCopy: string, successMessage?: string):void {
    if ('clipboard' in navigator) {
      this.newCopy(textToCopy, successMessage)
    } else {
      this.legacyCopy(textToCopy, successMessage)
    }
  }

  private newCopy(text:string, successMessage?: string) {
    // eslint-disable-next-line compat/compat
    navigator.clipboard.writeText(text)
      .then(() => this.success(successMessage))
  }

  private legacyCopy(text:string, successMessage?: string) {
    // eslint-disable-next-line compat/compat
    const tempInput = document.createElement('input')
    // eslint-disable-next-line id-blacklist
    tempInput.value = text
    document.body.append(tempInput)
    tempInput.select()
    document.execCommand('copy')
    tempInput.remove()

    this.success(successMessage)
  }

  private success(successMessage?: string) {
    successNotificationWrapper(successMessage ?? this.$t('success_copy').toString(), '')
  }
}
